import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { BlockStyle, BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

@Component({
  selector: 'app-check-list',
  standalone: true,
  templateUrl: './check-list.component.html',
  styleUrls: ['./check-list.component.scss'],
  imports: [CommonModule, BlockWrapperComponent, SvgComponent],
})
export class CheckListComponent {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() style: BlockStyle[];
  @Input() checks: { text: string }[];
}
